export var MAIN_THEME = {
  baseColor: "#e5e5e5",
  highlightColor: "#efefef"
};